import {copyLinkItems} from "./helper/copyLinkItems";
import {PageType} from "../../../enums/PageType";
import {copyCustomFields} from "./helper/copyCustomFields";
import {getInitData} from "./helper/getInitData";
import { SubscriptionCheck } from "../../../components/Access/helper/subscription/SubscriptionCheck";
import { SubscriptionScopeKey } from "../../../components/Access/helper/subscription/enum/SubscriptionScopeKey";
import { showConfirmationModalPromise } from "./helper/Modal/showConfirmationModalPromise";
import { select } from "redux-saga/effects";
import _ from "lodash";
import { readAutosaveStorage } from "../../LocalStorage/helpers/AutosaveTransactions/readStorage";
import { showWillOverrideAutosaveDataPromise } from "./helper/Modal/showWillOverrideAutosaveDataPromise";
import { Type } from "../helper";
import { getDisplayName } from "../../../containers/AppPage/Contacts/ContactFormGroup";

// Case 3: Pay
// - Sales Invoice       => Sales Payment
// - Sales CN            => Sales Refund
// - Sales Payment       => Sales Refund
// - Bill                => Purchase Payment
// - Purchase CN         => Purchase Refund
// - Purchase Payment    => Purchase Refund
export function* pay(transactionType, originType, originTransaction = {}) {
    // Check if there's any autosaved data for the transaction type, and prompt modal if there is
    const { data, last_saved } = yield readAutosaveStorage(transactionType) || {};

    if (data) {
        let action;
        if ([Type.sale_payment, Type.purchase_payment].includes(transactionType))
            action = 'payment';
        else
            action = 'refund';

        const autosaveModalRef = yield select(state => state.Transaction.autosaveModalRef);
        const isProceed = yield showWillOverrideAutosaveDataPromise(
            transactionType, autosaveModalRef, last_saved, action);
        if (!isProceed)
            return {isProceed: false, transaction: null};
    }

    // Init Data
    const companyCurrencyCode = yield select(state => state.Auth.companyCurrencyCode);
    const initData = yield getInitData(transactionType);
    const { linkItems } = yield copyLinkItems(PageType.pay, transactionType, originTransaction);
    const fields = yield copyCustomFields(transactionType, originType, originTransaction);

    const hasTagSub = SubscriptionCheck.withKeys(SubscriptionScopeKey.TAG).hasSubscriptionTo();
    const hasCustomFieldsSub =
        SubscriptionCheck.withKeys(SubscriptionScopeKey.CUSTOM_FIELD).hasSubscriptionTo();
    const hasMultiCurrencySub =
        SubscriptionCheck.withKeys(SubscriptionScopeKey.MULTI_CURRENCY).hasSubscriptionTo();

    const contacts = yield select(state => state.List.contacts);
    const contactPersons = yield select(state => state.List.contactPersons);

    const contact = contacts.find(c => c.id === originTransaction.contact_id);
    const billingContactPerson = contactPersons.find(c => {
        if (originTransaction.billing_contact_person_id)
            return c.id === originTransaction.billing_contact_person_id;

        return c.is_default_billing;
    });

    console.log('originTransaction', {
        originTransaction,
        initData,
    });
    const transaction = {
        ...initData,
        type: transactionType,
        number2: originTransaction.number,
        // Copy from Invoice / Bill
        contact_id: originTransaction.contact_id,
        billing_party: originTransaction.billing_party ?? contact?.billing_party,
        billing_contact_person: getDisplayName(billingContactPerson),
        billing_contact_person_id: billingContactPerson?.id,

        currency_code: hasMultiCurrencySub ? originTransaction.currency_code : companyCurrencyCode,
        exchange_rate: hasMultiCurrencySub ? originTransaction.exchange_rate : 1,
        amount: hasMultiCurrencySub ? originTransaction.balance : 0,
        tag_ids: hasTagSub ? originTransaction.tag_ids || [] : undefined,

        link_items: linkItems,
        fields: hasCustomFieldsSub ? fields : undefined,
    };

    // compare the 2 transactions' fields without 'id'
    // fields.length === 0 means that the 2 transactions don't share any same fields
    // const hasFieldChange = (!hasCustomFieldsSub && (fields || []).length === 0) ? false : _.differenceWith(
    //     originTransaction.fields,
    //     transaction.fields,
    //     (a, b) => _.isEqual(_.omit(a, 'id'), _.omit(b, 'id'))).length !== 0;
    const hasFieldChange = !hasCustomFieldsSub && !!(fields || []).find(f => f.value);
    const hasCurrencyCodeChange = originTransaction.currency_code !== transaction.currency_code;
    const hasTagChange = !_.isEqual(originTransaction.tag_ids || [], transaction.tag_ids || []);

    if (hasFieldChange || hasCurrencyCodeChange || hasTagChange) {
        yield showConfirmationModalPromise([], [], { hasFieldChange, hasCurrencyCodeChange, hasTagChange })
            .then(() => {});
    }

    // return transaction;
    // Remove all ids
    return {
        isProceed: true,
        transaction,
    };
}
